// IM-XPR-001 (IM-UX-111) — Os cinco objetivos, em linguagem natural: resultado esperado, situação e próxima ação.
// Nenhum código de jornada, nenhum nome técnico de domínio.
import { Link } from 'react-router-dom';
import { OBJECTIVE_STATUS_LABEL, type ObjectiveKey } from '@intelimove/contracts';
import { objectiveHref, type ObjectiveSummary } from './data';

export const OBJECTIVE_GLYPH: Record<ObjectiveKey, string> = { planejar: '⌁', concorrentes: '◉', empresas: '⌂', ofertas: '◇', 'acompanhar-plano': '↗' };

export function ObjectiveCards({ items, headingLevel = 3 }: { items: readonly ObjectiveSummary[]; headingLevel?: 2 | 3 }) {
  const H = headingLevel === 2 ? 'h2' : 'h3';
  return (
    <ul className="xp-goals" role="list">
      {items.map((o) => {
        const phase = o.phases?.find((p) => p.current);
        return (
          <li key={o.def.key}>
            <Link to={objectiveHref(o.def.key, phase?.key)} className={`xp-goal${o.status === 'CONTINUAR' ? ' active' : ''}${o.status === 'EM_PREPARACAO' ? ' soon' : ''}`}>
              <span className="xp-goal-icon" aria-hidden="true">{OBJECTIVE_GLYPH[o.def.key]}</span>
              <H>{o.def.title}</H>
              <p>{o.def.outcome}</p>
              {o.next && <p className="xp-goal-next">{o.next}</p>}
              <span className="xp-goal-state"><span className="sr-only">Situação: </span>{OBJECTIVE_STATUS_LABEL[o.status]}</span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
}
